<template>
    <div class="container is-fullhd">
      <section class="section">
        <div>You'll receive books content to this email address: <strong>{{ userEmail }}</strong>.</div>
        <newsletter-checkbox/>
      </section>
      <user-progress/>
    </div>
</template>

<script>
import newsletterCheckbox from '@/components/newsletter-checkbox'
import userDiscoverEbooksList from '@/components/user-discover-ebooks-list'
import userEbooksList from '@/components/user-ebooks-list'
import userProgress from '@/components/user-progress'

export default {
  name: 'userEbooks',
  computed: {
    userEmail () {
      const user = this.$store.getters.isAuthenticated
      if (user) {
        return user.email
      }
      return ''
    }
  },
  components: {
    newsletterCheckbox,
    userDiscoverEbooksList,
    userEbooksList,
    userProgress
  }
}
</script>

<style>

</style>
